module.exports = __webpack_public_path__ + "img/close_black_big.8d936884.png";